import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { ConfigService } from './services/config.service';
import {FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class PrismService {

  private _baseUrl: string | null = null;
  private _invitationURl: string | null = null;

  constructor(
    private http: HttpClient, 
    private toastrService: ToastrService, 
    private router: Router,
    private configService: ConfigService
  ) {
    // Configuration will be loaded lazily when accessed
  }

  // Lazy load baseUrl when first accessed
  private get baseUrl(): string {
    if (!this._baseUrl) {
      this._baseUrl = this.configService.getApiUrl();
    }
    return this._baseUrl;
  }

  // Lazy load invitationURl when first accessed (public for external access)
  get invitationURl(): string {
    if (!this._invitationURl) {
      this._invitationURl = this.configService.getInvitationUrl();
    }
    return this._invitationURl;
  }


  getToken() {
    return localStorage.getItem('token');
  }

  loggedIn() {
    if (localStorage.getItem('token') == 'undefined' || localStorage.getItem('token') === '') {
      return !!localStorage.getItem('0')
    }
    return !!localStorage.getItem('token')
  }

  checkURL(userId){
    return this.http.get(`${this.baseUrl}/Account/CheckUserURLValidity?userId=${userId}`)
  }
//---------------------------------------------------- ALL Question------------------------------------------------//
  getAllQuestion(){
    return this.http.get(`${this.baseUrl}/ASMQuestions/GetAllASMQuestions?isRoleCandidate=true`)
   }
   //get All Question for asm in candidate //
   getAllQuestionSP(pageNumber,pageSize,testeventId,candidateId,isPrevious){
    return this.http.get(`${this.baseUrl}/ASMQuestions/GetAllASMQuestionsV1?pageIndex=${pageNumber}&pageSize=${pageSize}&testeventId=${testeventId}&CandidateId=${candidateId}&IsRandom=true&isPrevious=${isPrevious}`)
   }
   
  //  Get all button panel for asm//
  getbuttonpanel(testeventId,candidateId){
   return this.http.get(`${this.baseUrl}/ASMQuestions/GetAllASMQuestions_sidepanelV1?&testeventId=${testeventId}&CandidateId=${candidateId}`)
  }

  getAllLOCQuestion(){
    return this.http.get(`${this.baseUrl}/RPI/GetAllRPILOCQuestion?isRoleCandidate=false`)
  }
  getAllSAFEQuestion(){
    return this.http.get(`${this.baseUrl}/RPI/GetAllRPISAFEQuestion?isRoleCandidate=true`)
  }
   getAllOPAQuestion(){
    return this.http.get(`${this.baseUrl}/RPI/GetAllRPIOPAQuestion?isRoleCandidate=false`)
   }
   getAllCOSQuestion(){
    return this.http.get(`${this.baseUrl}/RPI/GetAllRPICOSQuestion?isRoleCandidate=false`)
   }
   //-----------------------------------------------------ASM-------------------------//
  AddAsmQuestion(Question){
  return this.http.post(`${this.baseUrl}/ASMQuestions/CreateQuestion`,Question)
 }

  EditAsmQuestion(questionData){
  return this.http.put(`${this.baseUrl}/ASMQuestions/UpdateQuestion`,questionData)
 }

 deleteAsmQuestion(asmQuestionId){
 return this.http.delete(`${this.baseUrl}/ASMQuestions/DeleteASMQuestion?asmQuestionId=${asmQuestionId}`);
 }

 //-----------------------------------------------------OPA-------------------------//
AddOpaQuestion(opaQuestion){
  return this.http.post(`${this.baseUrl}/RPI/Add`,opaQuestion)
}

EditOpaQuestion(opaQuestion){
  return this.http.put(`${this.baseUrl}/RPI/Update`,opaQuestion)
}

deleteOpaQuestion(rpiQuestionId){
  return this.http.delete(`${this.baseUrl}/RPI/DeleteById?rpiQuestionId=${rpiQuestionId}`);
  }

AddLocQuestion(locQuestion){
  return this.http.post(`${this.baseUrl}/RPI/Add`,locQuestion)
}

EditLocQuestion(locQuestion){
  return this.http.put(`${this.baseUrl}/RPI/Update`,locQuestion)
}

deleteLocQuestion(rpiQuestionId){
  return this.http.delete(`${this.baseUrl}/RPI/DeleteById?rpiQuestionId=${rpiQuestionId}`);
  }
  //-----------------------------------------------COS------------------------------//
  AddCosQuestion(cosQuestion){
    return this.http.post(`${this.baseUrl}/RPI/Add`,cosQuestion)
  }

  EditCosQuestion(cosQuestion){
    return this.http.put(`${this.baseUrl}/RPI/Update`,cosQuestion)
  }

  deleteCosQuestion(rpiQuestionId){
    return this.http.delete(`${this.baseUrl}/RPI/DeleteById?rpiQuestionId=${rpiQuestionId}`);
    }

//-------------------------------------------------------SAFE---------------------------------------------------//

AddSafeQuestion(safeQuestion){
  return this.http.post(`${this.baseUrl}/RPI/Add`,safeQuestion)
}

EditSafeQuestion(safeQuestion){
  return this.http.put(`${this.baseUrl}/RPI/Update`,safeQuestion)
}

deleteSafeQuestion(rpiQuestionId){
  return this.http.delete(`${this.baseUrl}/RPI/DeleteById?rpiQuestionId=${rpiQuestionId}`);
  }

  getGenericById(testEventId) {
    return this.http.get(`${this.baseUrl}/TestEvent/GetByIdgeneric?testEventId=${testEventId}`);
    }
    //---------------------- Get Generic Link-------------------------------//
  getGenericLinkInfo(testEventId) {
    return this.http.get(`${this.baseUrl}/TestEvent/GenericLinkInfo?TestEventId=${testEventId}`);
   }
  //--------------- Add Candidate--------------------------------//
   createCandidate(candidateData) {
   return this.http.post(`${this.baseUrl}/candidate/AddV1`, candidateData);
  }
  
  createGenericCandidate(candidateData) {
    return this.http.post(`${this.baseUrl}/Candidate/GenericAdd`, candidateData); 
   }

   createGenericSubmitCandidate(candidateData) {
    return this.http.post(`${this.baseUrl}/Candidate/Genericsubmitcandidate`, candidateData); 
   }

  getUserIdByEmail(candidateData) {
   return this.http.post(`${this.baseUrl}/Candidate/GetCandidatesByEmailIdForGeneric`, candidateData);
  }
   
  
  checkCandidate(candidateDetails){
    return this.http.post(`${this.baseUrl}/Candidate/CheckCandidateExistorNot`, candidateDetails)
  }

  AddAsmAnswer(answer){
    return this.http.post(`${this.baseUrl}/ASMQuestions/ASMAnswers`,answer)
  }

  AddAsmAnswerNew(ASMAnswer){
    return this.http.post(`${this.baseUrl}/ASMQuestions/ASMAnswersV2`,ASMAnswer)
  }

  getASMAnswer(candidateId, testEventId){
    return this.http.get(`${this.baseUrl}/ASMQuestions/GetCandidateAnswersList?candidateId=${candidateId}&testEventId=${testEventId}`);
  }

  verifyUser(userId){
    return this.http.put(`${this.baseUrl}/Account/ConfirmUserEmail?userId=${userId}`, 'dskfhjdsk');
  }

        logOut() {
          localStorage.clear();
          this.router.navigate(['/login']);
        }

      comparePasswords(fb: FormGroup) {
        const confirmPswrdCtrl = fb.get('ConfirmPassword');
        const enteredPassword = fb.get('Password');
        const passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

        if (enteredPassword.errors == null || 'invalid' in enteredPassword.errors) {           
            if (!enteredPassword.value.match(passwordCheck)) {
            enteredPassword.setErrors({ invalid: true });
            } else {
            enteredPassword.setErrors(null);
            }
          }
        if (confirmPswrdCtrl.errors == null || 'passwordMismatch' in confirmPswrdCtrl.errors) {
            if (enteredPassword.value !== confirmPswrdCtrl.value) {
              confirmPswrdCtrl.setErrors({ passwordMismatch: true });
            } else {
              confirmPswrdCtrl.setErrors(null);
            }
          }
      }

  loginUser(userDetails) {
    return this.http.post(`${this.baseUrl}/Account/Login`, userDetails);
  }

  recoverPassword(userEmail) {

    const auth = {
        email: userEmail,
        isforgotpassword:true
      }
    return this.http.post(`${this.baseUrl}/Account/ForgotPassword`, auth);
  }
  activatePassword(userEmail) {

    const auth = {
        email: userEmail,
        isforgotpassword:false
      }
    return this.http.post(`${this.baseUrl}/Account/ForgotPassword`, auth);
  }

  changePassword(newPasswordDetails) {
    
    return this.http.post(`${this.baseUrl}/Account/SetPassword`, newPasswordDetails);
  }

  getUserDetails(UserId){
    return this.http.get(`${this.baseUrl}/Account/GetUserProfileById?UserId=${UserId}`)
  }

  getCandidateReport(candidateId, testEventId){
    return this.http.post(`${this.baseUrl}/ASMQuestions/GetCandidateReport?candidateId=${candidateId}&testEventId=${testEventId}`, 'akjshdfkjsah')
  }

    showToaster(message) {
      this.toastrService.success(message);
    }
    ErrorSuccess(message) {
      this.toastrService.error(message);
    }
    infoSuccess(message) {
      this.toastrService.info(message);
    }
    warningSuccess(message) {
      this.toastrService.warning(message);
    }
    showToaster1(message) {
      this.toastrService.success(message,null,{timeOut: 10000});
    }
    ErrorSuccess1(message) {
      this.toastrService.error(message , null, { timeOut: 10000 });
    }
}

